import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialInstitutionContractByTrialInstitutionId: ITrialInstitutionContractLoadByTrialInstitutionIdActionCreator = (trialInstitutionId) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_TRIAL_INSTITUTION_ID,
            trialInstitutionId
        }
    },
    LoadTrialInstitutionContractById: ITrialInstitutionContractLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialInstitutionContractLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialInstitutionContractLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialInstitutionContract: ITrialInstitutionContractSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialInstitutionContractSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialInstitutionContractSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialInstitutionContract: ITrialInstitutionContractValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialInstitutionContractValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialInstitutionContractValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialInstitutionContract: ITrialInstitutionContractCreateActionCreator = (trialInstitutionId) => {

        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_CREATE,
            trialInstitutionId
        }
    },
    CreateSuccess: ITrialInstitutionContractCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialInstitutionContractCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteTrialInstitutionContract: ITrialInstitutionContractDeleteActionCreator = (id) => {
    
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_DELETE,
            id
        }
    },
    DeleteSuccess: ITrialInstitutionContractDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_DELETE_SUCCESS
        }
    },
    DeleteFailure: ITrialInstitutionContractDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_DELETE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialInstitutionContractClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialInstitutionContractFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALINSTITUTIONCONTRACT_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_TRIAL_INSTITUTION_ID = "ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_TRIAL_INSTITUTION_ID",
    ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_ID = "ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_ID",
    ACTION_TRIALINSTITUTIONCONTRACT_LOAD_SUCCESS = "ACTION_TRIALINSTITUTIONCONTRACT_LOAD_SUCCESS",
    ACTION_TRIALINSTITUTIONCONTRACT_LOAD_FAILURE = "ACTION_TRIALINSTITUTIONCONTRACT_LOAD_FAILURE",

    ACTION_TRIALINSTITUTIONCONTRACT_SAVE = "ACTION_TRIALINSTITUTIONCONTRACT_SAVE",
    ACTION_TRIALINSTITUTIONCONTRACT_SAVE_SUCCESS = "ACTION_TRIALINSTITUTIONCONTRACT_SAVE_SUCCESS",
    ACTION_TRIALINSTITUTIONCONTRACT_SAVE_FAILURE = "ACTION_TRIALINSTITUTIONCONTRACT_SAVE_FAILURE",

    ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE = "ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE",
    ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_SUCCESS = "ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_SUCCESS",
    ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_FAILURE = "ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_FAILURE",

    ACTION_TRIALINSTITUTIONCONTRACT_CREATE = "ACTION_TRIALINSTITUTIONCONTRACT_CREATE",
    ACTION_TRIALINSTITUTIONCONTRACT_CREATE_SUCCESS = "ACTION_TRIALINSTITUTIONCONTRACT_CREATE_SUCCESS",
    ACTION_TRIALINSTITUTIONCONTRACT_CREATE_FAILURE = "ACTION_TRIALINSTITUTIONCONTRACT_CREATE_FAILURE",

    ACTION_TRIALINSTITUTIONCONTRACT_DELETE = "ACTION_TRIALINSTITUTIONCONTRACT_DELETE",
    ACTION_TRIALINSTITUTIONCONTRACT_DELETE_SUCCESS = "ACTION_TRIALINSTITUTIONCONTRACT_DELETE_SUCCESS",
    ACTION_TRIALINSTITUTIONCONTRACT_DELETE_FAILURE = "ACTION_TRIALINSTITUTIONCONTRACT_DELETE_FAILURE",

    ACTION_TRIALINSTITUTIONCONTRACT_CLEAR = "ACTION_TRIALINSTITUTIONCONTRACT_CLEAR",

    ACTION_TRIALINSTITUTIONCONTRACT_FILTER = "ACTION_TRIALINSTITUTIONCONTRACT_FILTER";

export interface ITrialInstitutionContractLoadByTrialInstitutionIdAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_TRIAL_INSTITUTION_ID";
    trialInstitutionId: number;
}

export interface ITrialInstitutionContractLoadByTrialInstitutionIdActionCreator {
    (trialInstitutionId: number): ITrialInstitutionContractLoadByTrialInstitutionIdAction;
}

export interface ITrialInstitutionContractLoadSuccessAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_LOAD_SUCCESS";
    formData: Dtos.TrialInstitutionContract | Dtos.TrialInstitutionContract[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionContractLoadSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionContract | Dtos.TrialInstitutionContract[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionContractLoadSuccessAction;
}

export interface ITrialInstitutionContractLoadFailureAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionContractLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionContractLoadFailureAction;
}

export interface ITrialInstitutionContractLoadByIdAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_ID";
    id: number;
}

export interface ITrialInstitutionContractLoadByIdActionCreator {
    (id: number): ITrialInstitutionContractLoadByIdAction;
}

export interface ITrialInstitutionContractSaveAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_SAVE";
    formData: Dtos.TrialInstitutionContract;

}

export interface ITrialInstitutionContractSaveActionCreator {
    (
        formData: Dtos.TrialInstitutionContract
    ): ITrialInstitutionContractSaveAction;
}

export interface ITrialInstitutionContractSaveSuccessAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_SAVE_SUCCESS";
    formData: Dtos.TrialInstitutionContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionContractSaveSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionContractSaveSuccessAction;
}

export interface ITrialInstitutionContractSaveFailureAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionContractSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionContractSaveFailureAction;
}

export interface ITrialInstitutionContractValidateAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE";
    formData: Dtos.TrialInstitutionContract;

}

export interface ITrialInstitutionContractValidateActionCreator {
    (
        formData: Dtos.TrialInstitutionContract
    ): ITrialInstitutionContractValidateAction;
}

export interface ITrialInstitutionContractValidateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_SUCCESS";
    formData: Dtos.TrialInstitutionContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionContractValidateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionContractValidateSuccessAction;
}

export interface ITrialInstitutionContractValidateFailureAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionContractValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionContractValidateFailureAction;
}

export interface ITrialInstitutionContractCreateAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_CREATE",
    trialInstitutionId: number
}

export interface ITrialInstitutionContractCreateActionCreator {
    (trialInstitutionId: number): ITrialInstitutionContractCreateAction
}

export interface ITrialInstitutionContractCreateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_CREATE_SUCCESS";
    formData: Dtos.TrialInstitutionContract;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialInstitutionContractCreateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionContract,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialInstitutionContractCreateSuccessAction;
}

export interface ITrialInstitutionContractCreateFailureAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionContractCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionContractCreateFailureAction;
}

export interface ITrialInstitutionContractDeleteAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_DELETE";
    id: number;
}

export interface ITrialInstitutionContractDeleteActionCreator {
    (id: number): ITrialInstitutionContractDeleteAction
}

export interface ITrialInstitutionContractDeleteSuccessAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_DELETE_SUCCESS";
}

export interface ITrialInstitutionContractDeleteSuccessActionCreator {
    (): ITrialInstitutionContractDeleteSuccessAction;
}

export interface ITrialInstitutionContractDeleteFailureAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionContractDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionContractDeleteFailureAction;
}

export interface ITrialInstitutionContractClearAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialInstitutionContractClearActionCreator {
    (propertiesToClear?: string[]): ITrialInstitutionContractClearAction;
}

export interface ITrialInstitutionContractFilterActionCreator {
    (formFilter: IFormFilter): ITrialInstitutionContractFilterAction;
}

export interface ITrialInstitutionContractFilterAction {
    type: "ACTION_TRIALINSTITUTIONCONTRACT_FILTER";
    formFilter: IFormFilter;
}

export type TrialInstitutionContractAction =
    ITrialInstitutionContractLoadByTrialInstitutionIdAction |
    ITrialInstitutionContractLoadByIdAction |
    ITrialInstitutionContractLoadFailureAction |
    ITrialInstitutionContractLoadSuccessAction |
    ITrialInstitutionContractSaveAction |
    ITrialInstitutionContractSaveSuccessAction |
    ITrialInstitutionContractSaveFailureAction |
    ITrialInstitutionContractValidateAction |
    ITrialInstitutionContractValidateSuccessAction |
    ITrialInstitutionContractValidateFailureAction |
    ITrialInstitutionContractCreateAction |
    ITrialInstitutionContractCreateSuccessAction |
    ITrialInstitutionContractCreateFailureAction |
    ITrialInstitutionContractDeleteAction |
    ITrialInstitutionContractDeleteSuccessAction |
    ITrialInstitutionContractDeleteFailureAction |
    ITrialInstitutionContractClearAction | 
    ITrialInstitutionContractFilterAction;
